// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { AUFTRAG_API } from '@Constants/backendConstants';

import { EnumDirection } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useListApi } from '@Hooks/useListApi';
import { RequisitionsRepository } from '@Repositories/Auftragsbearbeitung';

/** The most recently created requisitions, newest first. */
export function useRecentRequisitions(pageSize: number, enabled: boolean) {
    const { loadPage } = useListApi(RequisitionsRepository, AUFTRAG_API, ['Site', 'Positions', 'ContainerActions']);

    const { data, isLoading } = useQuery({
        queryFn: () =>
            loadPage({
                page_no: 0,
                page_size: pageSize,
                full_text_search: '',
                sort_columns: [{ column_name: 'created_at', direction: EnumDirection.DESC }],
            }),
        queryKey: ['requisitions', 'recent', pageSize],
        enabled,
    });

    return {
        requisitions: data?.items,
        isLoading,
    };
}
